import React, {Component, Fragment} from 'react';

import LandingCompanyUniverse from './LandingCompanyUniverse.jsx';

import businessControllingImg from '../../../media/images/sub-universes/finance/businessControlling.jpg?size=600';
import cfoImg from '../../../media/images/sub-universes/finance/cfo.jpg?size=600';
import consolidationImg from '../../../media/images/sub-universes/finance/consolidation.jpg?size=600';
import headerImg from '../../../media/images/universes/finance.jpg';

const headerBrief = <Fragment>
  <p>
    Que vous recherchiez <strong>un expert, un renfort pour vos équipes ou un manager de transition Finance</strong>
    , Twineeds est la plateforme qu'il vous faut.
  </p>
  <p>Accédez directement à nos consultants ou consultez nous directement avec votre recherche.</p>
</Fragment>;

const metaDescription = "Découvrez les différents profils de consultants Finance inscrits sur notre plateforme : " +
  "expert, renfort temporaire pour vos équipes ou manager de transition";

const ourJobsItems = [
  {
    title: 'Direction Administrative et Financière',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> autour de la fonction <strong>' +
      'Direction de votre service Finance</strong>.</p><p>Tout types de postes liés à cette fonction : ' +
      '<strong>Directeur Administratif et Financier, Responsable Administratif et Comptable</strong> etc.</p>',
    img: cfoImg.src
  },
  {
    title: 'Contrôle de gestion',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> autour du contrôle de gestion : <strong>' +
      'responsable contrôle de gestion, contrôleur de gestion (industriel, IT...)</strong> etc.</p>',
    img: businessControllingImg.src
  },
  {
    title: 'Consolidation',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> sur les problématiques liées à la consolidation' +
      'des bilans : <strong>responsable consolidation</strong> etc.</p>',
    img: consolidationImg.src
  }
];

const specificDifference = <Fragment>
  <strong>Une large gamme de compétences sur le secteur de la Finance</strong>, quand les cabinets sont généralement
  spécialisés.
</Fragment>;

export default class LandingCompanyFinance extends Component {
  render() {
    return <LandingCompanyUniverse
      headerBrief={headerBrief}
      headerImg={headerImg.src}
      metaDescription={metaDescription}
      metaOgDescription={metaDescription}
      metaTitle="Twineeds : consultants indépendants Finance"
      metaOgTitle="Twineeds : consultants indépendants Finance"
      ourJobsItems={ourJobsItems}
      specificDifference={specificDifference}
      title="Besoin de spécialistes de la Finance d'entreprise ?"
      universeCode="finance"
    />;
  }
}
